<template>
  <div>
    <div class="side-frame-success d-flex">
      <div>
        <span style="font-size: 14px; color:#6C6C6C;line-height: 28px;">
          {{ $l('table_label_fabric_list') || '面料列表' }}
        </span>
      </div>

      <!-- <SearchTabs
        class="ml-2"
        v-model="tab"
        :options="searchTabOpts"
        @change="changeTab"
      ></SearchTabs> -->
      <div style="width: 80%;">
        <b-row class="ml-2">
          <b-col cols="5" style="padding-right: 7px;">
            <b-form @reset="reset" onsubmit="return false">
              <b-input-group size="sm">
                <b-form-input
                  @keyup.enter="query"
                  type="search"
                  v-model.trim="form.searchKey"
                  :placeholder="
                    $l('form_label_fabric_search') ||
                      '面料编号/面料工厂编号/面料名称/面料成分 搜索...'
                  "
                />
                <b-input-group-append>
                  <b-button-group>
                    <b-button-group slot="reference">
                      <b-button variant="primary" size="sm" @click="query">
                        <i class="fa fa-search" />
                      </b-button>
                    </b-button-group>
                  </b-button-group>
                </b-input-group-append>
                <slot />
              </b-input-group>
            </b-form>
          </b-col>
          <b-button
            v-if="allow('A') && addFabric"
            size="sm"
            variant="outline-primary"
            @click="$emit('handleCommand')"
          >
            {{ $l('btn_new_fabric') || '新增面料' }}
          </b-button>

          <!-- <el-badge
            v-if="allow('SS') && addFabric"
            :value="checkedCount"
            class="item"
            style="margin-bottom: 1px;"
          >
            <b-button
              class="ml-2"
              size="sm"
              variant="outline-primary"
              v-if="allow('SS') && addFabric"
              :disabled="!checkedCount"
              style="width:135px;"
              @click="$emit('informationReview')"
            >
              {{
                $l('btn_batch_submission_information_review') ||
                  '批量提交面料审核'
              }}
            </b-button>
          </el-badge> -->
          <b-button
            class="ml-2"
            size="sm"
            variant="outline-success"
            @click="$emit('chooseFabricVisible')"
            v-if="allow('SC') && addFabric"
          >
            {{ $l('table_label_SelectExistingFabric') || '选择已有面料' }}
          </b-button>

          <el-badge
            v-if="allow('SR') && addFabric"
            :value="checkedCount"
            style="margin-bottom: 1px;"
            class="item"
          >
            <b-button
              class="ml-2"
              size="sm"
              variant="outline-danger"
              v-if="allow('SR') && addFabric"
              :disabled="!checkedCount"
              @click="$emit('remove')"
            >
              {{ $l('btn_remove_fabric') || '移除面料' }}
            </b-button>
          </el-badge>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
// import SearchTabs from './tabs'
// 初始表单
const initForm = {
  searchKey: '',
  fabricStatusList: ['Q', 'Y'],
}
export default {
  // components: { SearchTabs },

  props: {
    checkedCount: { type: Number, default: 0 },
    addFabric: { type: Boolean, default: false },
  },
  data() {
    return {
      form: { ...initForm },
      tab: 'ALL',
    }
  },
  computed: {
    searchTabOpts() {
      return [
        {
          label: '全部',
          value: 'ALL',
        },
        {
          label: '企划',
          value: 'Q',
        },
        {
          label: '已确认',
          value: 'C',
        },
        {
          label: '可下单',
          value: 'P',
        },
        {
          label: '正式',
          value: 'Y',
        },
      ]
    },
  },

  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', {
        ...this.form,
      })
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    changeTab(value) {
      this.tab = value
      this.query()
      this.$emit('resetChecked')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}

.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid #67c23a;
  margin: 6px 0;
}
</style>
